<template>
  <v-card class="mx-auto mb-12" outlined style="min-height: 85vh;" v-if="contents_type != 30 && isShow">
    <v-card-title class="push_title nl2br mt-5 text-left">{{item.title}}</v-card-title>
    <v-divider class="vdbar"></v-divider>
    <div v-if="item.image_url" class="noticeImg">
      <v-img :src="item.image_url" lazy-src="@/assets/nophoto.png" class="rounded elevation-2" />
    </div>
    <div class="push_contents" v-if="contents_type != 1 && contents_type != 2" v-html="item.push_comment"></div>
    <div class="push_contents" v-else-if="contents_type == 1 || contents_type == 2" v-html="autoHyperLink(item.comment)"></div>
    <div class="push_contents" v-else v-html="item.comment"></div>
    <div class="text-center pt-10 pb-3">
      <v-btn rounded class="graybtn default_button" @click.stop="routerBack('notification_list', {shop_id: item.shop_id})">閉じる</v-btn>
    </div>
  </v-card>
  <!-- stamp memp -->
  <v-card class="mx-auto mb-12" outlined style="min-height: 85vh;" v-else-if="isShow">
    <v-card-title class="push_title nl2br mt-5 text-center">来店のご予定です</v-card-title>
    <v-divider class="vdbar"></v-divider>
    <div class="pa-4">
      <v-row no-gutters>
        <v-col cols="3" class="fontsize11 mb-3" style="color: #9D9D9D; line-height: 22px;">来店予定日</v-col>
        <v-col cols="9" class="fontsize13 mb-3" style="color: #333333; line-height: 22px;">{{item.memo_date}}</v-col>
        <v-col cols="3" class="fontsize11 mb-3" style="color: #9D9D9D; line-height: 22px;">時間</v-col>
        <v-col cols="9" class="fontsize13 mb-3" style="color: #333333; line-height: 22px;">{{item.memo_time}}</v-col>
        <v-col cols="3" class="fontsize11 mb-3" style="color: #9D9D9D; line-height: 22px;">メモ</v-col>
        <v-col cols="9" class="fontsize13 mb-3" style="color: #333333; line-height: 22px;">{{item.memo}}</v-col>
      </v-row>
      <p class="fontsize11 pt-3">予定の変更、キャンセルがございましたら店舗へのお問い合わせをお願いいたします。</p>
    </div>
    <v-divider class="mb-3"></v-divider>
    <div class="text-center pt-5 pb-3">
      <v-btn rounded class="graybtn default_button" @click.stop="routerBack">閉じる</v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    item: {
        type: Object,
        //required: true
    },
    contents_type: {
      default: Number
    }
  },
  watch: {
    item: function () {
      this.isShow = true;
    }
  },
  data: () => ({
    isShow: false
  }),
  methods: {
    autoHyperLink(obj) {
      if(typeof (obj) === "string" || obj instanceof String) {
        return obj.replace(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig,"<a href='$1' target='_blank' title='$1'>$1</a>");
      } else {
        return '';
      }
    }
  }
}
</script>

<style scoped>
/* vue css override */
.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 10px;
  margin-bottom: 40px;
}
/* original css */
.pushdetail {
  background-color: #EEEEEE;
  padding-top: 10px;
}
.detailhead {
  text-align: center;
  font-size: 11px;
  margin: 0 0 10px;
}
.topbar {
  height: 15px;
  margin-bottom: 15px;
}
.vdbar {
  width: 94%;
  margin: 16px auto 0;
}
.push_title {
  font-weight: bold;
  font-size: 18px;
  line-height: 27px;
  color: #333;
  text-align: center;
  display: block;
  padding: 10px 16px 5px;
}
.push_contents {
  padding: 16px;
}

/* NEW_DEV-2185 cyber start */
.push_contents >>> p{
  margin-bottom: 0px;
}
/* NEW_DEV-2185 cyber end */

.noticeImg {
  padding: 16px;
}
.noticeImg img {
  max-width: 100%;
}
</style>
